export default __webpack_public_path__ + "static/media/tongue.e12142e6.gif";